import React from 'react';
import styled from 'styled-components';

export function ProductCardsGrid({ children }): JSX.Element {
  return <Grid>{children}</Grid>;
}

const Grid = styled.div`
  margin: 25px 0 20px 0;
  display: grid;
  row-gap: 37px;
  column-gap: 37px;
  grid-auto-rows: minmax(245px, auto);
  grid-template-columns: 1fr 1fr;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    grid-template-columns: repeat(auto-fill, minmax(194px, 1fr));
    row-gap: 0;
    column-gap: 0;
  }
`;
